var exports = {
  "n": "authorLinkContainer__f13xan",
  "$": "authorNameLink__RYkc-M",
};

module.exports = exports;
